var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-home-product"},[_c('strong',[_vm._v("细致、精准、智能的国产化IoT产品设备适配方案")]),_c('p',[_vm._v("基于AIoT鸿蒙化替代升级服务，助您国产化升级，实现自主可控")]),_c('device')],1)}
var staticRenderFns = []

export { render, staticRenderFns }